import { handleActions } from "redux-actions";

import {
    PAGE_LAYOUTS_COMPLETE,
    PAGE_LAYOUTS_CREATE_COMPLETED,
    PAGE_LAYOUTS_DELETE_COMPLETED,
    PAGE_LAYOUTS_COPY_COMPLETED,
    PAGE_LAYOUTS_FETCH,
    PAGE_LAYOUTS_RESET,
    PAGE_LAYOUTS_UPDATE,
    PAGE_LAYOUTS_UPDATE_COMPLETED,
} from "constants/action-types";

const initialState = {
    allLayoutsFetched: false,
    error: undefined,
    isFetching: false,
    isUpdating: false,
    results: [],
};

export const pageLayouts = handleActions(
    {
        [PAGE_LAYOUTS_FETCH]: (state, { payload, error }: any) => {
            return {
                ...state,
                allLayoutsFetched: payload.length === 0,
                error,
                isFetching: true,
                results: state.results.concat(payload),
            };
        },
        [PAGE_LAYOUTS_COMPLETE]: (state, { error }) => {
            return {
                ...state,
                error,
                isFetching: false,
            };
        },
        [PAGE_LAYOUTS_RESET]: (state) => {
            return {
                ...state,
                results: [],
            };
        },
        [PAGE_LAYOUTS_CREATE_COMPLETED]: (state, { payload, error }) => {
            if (error) {
                return {
                    ...state,
                    error: payload,
                };
            }
            return {
                ...state,
                error,
                results: [...state.results, payload],
            };
        },
        [PAGE_LAYOUTS_DELETE_COMPLETED]: (state, { payload, error }) => {
            if (error) {
                return {
                    ...state,
                    error: payload,
                };
            }
            return {
                ...state,
                error,
                results: [...state.results.filter((result) => result !== payload)],
            };
        },
        [PAGE_LAYOUTS_COPY_COMPLETED]: (state, { payload, error }) => {
            if (error) {
                return {
                    ...state,
                    error: payload,
                };
            }
            return {
                ...state,
                error,
                results: [payload, ...state.results],
            };
        },
        [PAGE_LAYOUTS_UPDATE]: (state) => {
            return {
                ...state,
                isUpdating: true,
            };
        },
        [PAGE_LAYOUTS_UPDATE_COMPLETED]: (state, { payload, error }) => {
            if (error) {
                return {
                    ...state,
                    error: payload,
                };
            }
            return {
                ...state,
                isUpdating: false,
            };
        },
    },
    initialState,
);
